import React from "react";
import PropTypes from "prop-types";
import StyleMatchContext from "../../context/index.js";
function StyleMatchProvider(_ref) {
  var children = _ref.children,
    value = _ref.value;
  return /*#__PURE__*/React.createElement(StyleMatchContext.Provider, {
    value: value
  }, children);
}
process.env.NODE_ENV !== "production" ? StyleMatchProvider.propTypes = {
  children: PropTypes.node.isRequired,
  value: PropTypes.shape({}).isRequired
} : void 0;
export default StyleMatchProvider;